import {useEffect} from 'react';
import {useResizeObserver} from 'usehooks-ts';

import useIsDesktopLayout from '@/hooks/layout/useIsDesktopLayout';
import domService from '@/services/domService';

const useSidebarBarWidth = ({ref}) => {
    const {height, width} = useResizeObserver({ref});
    const isDesktop = useIsDesktopLayout();
    const SIDEBAR_WIDTH_VARIABLE = '--sidebar-width';
    const setSidebarVar = (val) =>
        domService.setCssVariable(SIDEBAR_WIDTH_VARIABLE, `${val}px`, {element: domService.getRoot()});

    useEffect(() => {
        if (!isDesktop) {
            setSidebarVar(0);
            return;
        }

        if (!width) return;

        setSidebarVar(width);
    }, [width, isDesktop]);

    useEffect(() => {
        return () => {
            setSidebarVar(0);
        };
    }, []);

    return {height, width};
};

export default useSidebarBarWidth;
